(function(){
  if(window.__wowcFree)return;window.__wowcFree=1;
  var DAY=864e5,WD=wowT('home.wd','So,Mo,Di,Mi,Do,Fr,Sa').split(',');
  var today;try{today=Date.parse(new Intl.DateTimeFormat('sv-SE',{timeZone:'Europe/Madrid'}).format(new Date)+'T00:00:00Z')}catch(e){today=Date.parse(new Date().toISOString().slice(0,10)+'T00:00:00Z')}
  function mn(b,s){var m=b.min;if(Array.isArray(m)){var d=new Date(s).toISOString().slice(5,10);for(var i=0;i<m.length;i++){var a=m[i];if(a&&a.length>2&&(a[0]<=a[1]?(d>=a[0]&&d<=a[1]):(d>=a[0]||d<=a[1])))return +a[2]||0}return 0}return +m||0}
  function md(t){return new Date(t).toISOString().slice(5,10)}
  function eur(n){return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' €'}
  function dd(t){var d=new Date(t);return WD[d.getUTCDay()]+' '+d.getUTCDate()+'.'+(d.getUTCMonth()+1)+'.'}
  function next(b){
    function price(t){var m=md(t);for(var i=0;i<b.s.length;i++){var a=b.s[i];if(a[0]<=a[1]?(m>=a[0]&&m<=a[1]):(m>=a[0]||m<=a[1]))return a[2]}return 0}
    function inSat(t){var m=md(t);return(b.sat||[]).some(function(a){return m>=a[0]&&m<=a[1]})}
    var bel=(b.bel||[]).map(function(x){return[Date.parse(x[0]+'T00:00:00Z'),Date.parse(x[1]+'T00:00:00Z')]});
    function blocked(t){for(var i=0;i<bel.length;i++)if(t>=bel[i][0]&&t<bel[i][1])return true;return false}
    for(var i=2;i<420;i++){
      var s=today+i*DAY,sat=inSat(s),L=sat?7:Math.max(+b.mindef||7,mn(b,s));
      if(sat&&new Date(s).getUTCDay()!==6)continue;
      var ok=true,sum=0;
      for(var k=0;k<L;k++){var t=s+k*DAY,p=price(t);if(!p||blocked(t)){ok=false;break}sum+=p}
      if(ok)return{s:s,n:L,sum:sum};
    }
    return null;
  }
  function run(){
    document.querySelectorAll('.wowc__free[data-wbc]:not([data-done])').forEach(function(el){
      el.setAttribute('data-done','1');var b;try{b=JSON.parse(el.getAttribute('data-wbc'))}catch(e){return}
      if(!b||!b.s)return;var it=el.closest('.wowf__item');
      /* 03.11.2026 (Gassi): Häuser ohne Saisonpreise (anf) sind nicht ausgebucht, sondern „Preis auf Anfrage“ */
      if(b.anf||!b.s.length){el.classList.add('is-anf');el.style.background='#f6f2ee';el.innerHTML='<i></i><div>'+wowT('home.price_request','Preis auf Anfrage – fragt uns nach eurem Termin')+'</div>';if(it)it.dataset.next=8e15;el.hidden=false;return}
      var x=next(b);
      if(x){el.innerHTML='<i></i><div>'+wowT('home.free_from_html','Frei ab <b>{d}</b><br>{n} Nächte fürs Haus',{d:dd(x.s),n:x.n})+'</div><span>'+eur(x.sum)+'</span>';if(it)it.dataset.next=x.s}
      else{el.classList.add('is-full');el.innerHTML='<i></i><div>'+wowT('home.booked_out','Gerade ausgebucht – fragt uns trotzdem')+'</div>';if(it)it.dataset.next=9e15}
      el.hidden=false;
    });
  }
  window.__wowcFreeRun=run; /* wowf-js ruft das nach dem Einsetzen der restlichen Finder-Kacheln auf (20.10.2026) */
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  setTimeout(run,1500);
})();
